import './ui.css';

/**
 * Fila reutilizable de "lista": icono + título + meta + slot derecho
 * (badge, chevron, etc.). Puede renderizarse como `<div>`, `<Link>` o
 * cualquier componente vía la prop `as`.
 *
 * @param {{
 *  as?: React.ElementType,
 *  icon?: React.ReactNode,
 *  title: React.ReactNode,
 *  meta?: React.ReactNode,
 *  right?: React.ReactNode,
 * }} props
 */
export default function ListItem({ as: Component = 'div', icon, title, meta, right, ...rest }) {
  return (
    <Component className="list-item" {...rest}>
      {icon && <span className="list-item__icon">{icon}</span>}
      <span className="list-item__body">
        <span className="list-item__title">{title}</span>
        {meta && <span className="list-item__meta">{meta}</span>}
      </span>
      {right}
    </Component>
  );
}
